import React, { useRef, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "./InfoButton.scss";

export default function InfoButton({ onClick }) {
  const btnRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });

  useEffect(() => {
    const btn = btnRef.current;
    if (!btn) return;

    const place = () => {
      const r = btn.getBoundingClientRect();
      setPos({
        top: r.top + window.scrollY - 35,
        left: r.left + window.scrollX + r.width / 2,
      });
    };

    const show = () => {
      place();
      setVisible(true);
    };

    const hide = () => {
      setVisible(false);
    };

    btn.addEventListener("mouseenter", show);
    btn.addEventListener("mouseleave", hide);

    return () => {
      btn.removeEventListener("mouseenter", show);
      btn.removeEventListener("mouseleave", hide);
    };
  }, []);

  return (
    <>
      <span
        ref={btnRef}
        role="button"
        tabIndex={0}
        className="info-btn"
        aria-label="Info"
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick?.();
          }
        }}
      >
        ℹ
      </span>

      {createPortal(
        <span
          className={
            "global-info-tooltip" +
            (visible ? " global-info-tooltip--visible" : "")
          }
          style={{
            top: pos.top,
            left: pos.left,
          }}
        >
          Details
        </span>,
        document.body,
      )}
    </>
  );
}
